import React, { useState, useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import Logo from "../Images/nahatalogo.jpeg";
import IconButton from "@mui/material/IconButton";
import "./Topbar.css";
import { MdLogout } from "react-icons/md";
import Swal from "sweetalert2";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";

export default function Main() {
  const [AgentID, setAgentID] = useState(0);

  useEffect(() => {
    GetUserDetails();
  }, []);

  const GetUserDetails = async () => {
    let obj = {
      query: `[dbo].[CRM_Proc_User_GetDetails] @SessionID='{0}'`,
      queryArr: [`${localStorage.getItem("SessionID")}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      const result = resp[""]?.[0];
      const cmd = result?.command;
      setAgentID(result?.agentid);
      if (cmd !== 1) {
        localStorage.removeItem("SessionID");
        window.location.href = "/login";
      }
    } catch {}
  };
  const Logoutpage = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out from your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("SessionID");
        window.location.href = "/login";
      }
    });
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg navbar-dark text-white"
        style={{ backgroundColor: "#000000" }}
      >
        <div className="container-fluid">
          <NavLink to="/dashboard">
            <img
              src={Logo}
              alt="Logo"
              style={{ width: "30px", height: "auto", borderRadius: "50%" }}
            />
          </NavLink>
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav ms-5 fs-5 gap-3">
              <li className="nav-item">
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active-link" : ""}`
                  }
                >
                  Dashboard
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/dg"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active-link" : ""}`
                  }
                >
                  DG (Jackson Cummins)
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/roadsafetysolutions"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active-link" : ""}`
                  }
                >
                  Road Safety Solutions
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/acp"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active-link" : ""}`
                  }
                >
                  ACP
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/water"
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active-link" : ""}`
                  }
                >
                  Water
                </NavLink>
              </li>
            </ul>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            <IconButton
              className="fw-bold text-black"
              style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                padding: "2px 10px",
                fontSize: "20px",
              }}
              onClick={() =>
                window.open(
                  "/customerenquiry?agentid=" + `${AgentID}`,
                  "_blank",
                )
              }
            >
              New
            </IconButton>
            <MdLogout
              style={{
                fontSize: "30px",
                cursor: "pointer",
              }}
              onClick={() => Logoutpage()}
            />
          </div>
        </div>
      </nav>

      <div className="container mt-1">
        <Outlet />
      </div>
    </>
  );
}
